import { actionToNavigationRoute, convertUser } from '@nextforce/api'
import { flatMap } from 'lodash'
import { CrewListResponse as Response } from './response'
import { CrewListData } from './types'

export function convertCrewList(response: Response.CrewList): CrewListData {
  const groupSummary = flatMap(response.groups, (group, index) => {
    const users = group.users
      ? group.users.map(user => convertUser(user))
      : undefined
    return [
      {
        id: String(index + 1),
        name: group.name,
        count: group.count,
        users,
        route: actionToNavigationRoute(group.actions[0]),
      },
    ]
  })

  const crewList = {
    title: response.title,
    groups: groupSummary,
  }

  return crewList
}
